// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenu-cls1_vE4","cls2":"AccountMenu-cls2_6Bu AccountMenu-cls1_vE4"};